module.exports = __webpack_public_path__ + "img/ears.bdbbb0db.svg";